import React, { useState } from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { getHalftimeCharacter } from "../../../utility/Utils"
import EditTimeComponent from "../../EditTimeComponent"
import styles from "./SetTimeModal.module.scss"

function SetTimeModal({ onParentDone }) {
	const [isOpen, setIsOpen] = useState(false)
	const [time, setTime] = useState("00:00")
	const [quarter, setQuarter] = useState("1" + getHalftimeCharacter())
	const [hasError, setHasError] = useState(false)

	const onDone = () => {
		if (!hasError) {
			setIsOpen(false)
			onParentDone(time, quarter)
		}
	}

	return (
		<>
			<Button color="primary" onClick={() => setIsOpen(true)}>
				Postavi vrijeme
			</Button>
			<Modal
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
				className="modal-dialog-centered modal-sm"
			>
				<ModalHeader toggle={() => setIsOpen(false)}>
					Postavi vrijeme
				</ModalHeader>
				<ModalBody className={styles.wrapper}>
					<EditTimeComponent
						initialTime={"00:00"}
						initialQuarter={"1Q"}
						time={time}
						setTime={setTime}
						quarter={quarter}
						setQuarter={setQuarter}
						setHasError={setHasError}
					/>
				</ModalBody>
				<ModalFooter>
					<Button color="primary" disabled={hasError} onClick={onDone}>
						Spremi
					</Button>
					<Button
						color="secondary"
						outline
						onClick={() => setIsOpen(false)}
					>
						Odustani
					</Button>
				</ModalFooter>
			</Modal>
		</>
	)
}

export default SetTimeModal
